export const ARTICLE_PAGE_VARIANTS = {
  ARTICLES: "articles",
  TEAM_MEMBERS: "team-members",
} as const;

export const HEADER_THRESHOLD = 100;
